// Modules
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgIdleModule } from '@ng-idle/core';
import { CdbDatatableModule } from 'cdb-datatable';
import { AppRoutingModule } from './app-routing.module';
import { AuthorizationModule } from './authorization.module';
import { CdbMaterialModule } from './cdb-material/cdb-material.module';

// Components
import { AppComponent } from './app.component';
import { ClientSearchComponent, HomeComponent, KeepSessionAliveComponent, MemberPortalLogoutComponent,
  MessageBoxModalComponent, PageNotFoundComponent, PortalCloseComponent, SsoLandingComponent, SsoLoginComponent,
  UnauthorizedComponent } from './shared/components';

// Services
import { AppConfigService } from './shared/services/app-config/app-config.service';

@NgModule({
  declarations: [
    AppComponent,
    ClientSearchComponent,
    HomeComponent,
    KeepSessionAliveComponent,
    MemberPortalLogoutComponent,
    MessageBoxModalComponent,
    PageNotFoundComponent,
    PortalCloseComponent,
    SsoLandingComponent,
    SsoLoginComponent,
    UnauthorizedComponent
  ],
  imports: [
    AuthorizationModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    CdbDatatableModule,
    ModalModule.forRoot(),
    NgIdleModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    BrowserAnimationsModule,
    CdbMaterialModule
  ],
  exports: [
    ClientSearchComponent,
    HomeComponent,
    KeepSessionAliveComponent,
    MemberPortalLogoutComponent,
    MessageBoxModalComponent,
    PageNotFoundComponent,
    PortalCloseComponent,
    SsoLandingComponent,
    SsoLoginComponent,
    UnauthorizedComponent
  ],
  providers: [
    { provide: 'ORIGIN_URL', useValue: location.origin },
    { provide: APP_INITIALIZER, useFactory: (config: AppConfigService) => () => config.load(), deps: [AppConfigService], multi: true },
    BsModalService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
